import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition } from "vue"

const _hoisted_1 = {
  class: "flex-node-col",
  style: {"position":"relative"}
}
const _hoisted_2 = {
  key: 0,
  class: "flex-container-row flex-item",
  style: {"justify-content":"right","margin":"5px"}
}
const _hoisted_3 = { style: {"position":"relative"} }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["id", "colspan", "aria-colindex", "aria-expanded", "aria-selected", "role", "data-grid-col-index"]
const _hoisted_6 = { class: "table-inner" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { style: {"display":"flex","flex-direction":"row","align-items":"center"} }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  class: "sales-text"
}
const _hoisted_12 = {
  key: 2,
  class: "node-category"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  id: "material-details-view-admin"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search_result_panel = _resolveComponent("search-result-panel")!
  const _component_k_label = _resolveComponent("k-label")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_search_match_viewer = _resolveComponent("search-match-viewer")!
  const _component_purchase_button = _resolveComponent("purchase-button")!
  const _component_my_icon = _resolveComponent("my-icon")!
  const _component_indicator = _resolveComponent("indicator")!
  const _component_material_explode_bar = _resolveComponent("material-explode-bar")!
  const _component_stock_indicator = _resolveComponent("stock-indicator")!
  const _component_tree_list = _resolveComponent("tree-list")!
  const _component_splitter = _resolveComponent("splitter")!
  const _component_close_button_header = _resolveComponent("close-button-header")!
  const _component_material_details = _resolveComponent("material-details")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_splitter, {
      panes: _ctx.splitterPanes,
      orientation: "horizontal",
      onChange: _ctx.onSplitterChange,
      class: "flex-node-col"
    }, {
      searchPanel: _withCtx(() => [
        _createVNode(_component_search_result_panel, {
          "search-input": _ctx.searchInput,
          data: _ctx.listData,
          "equipment-mode": _ctx.equipmentMode,
          onActiveMatch: _ctx.gotoSearchResult,
          onOnClose: _ctx.closeSearchPanel
        }, null, 8, ["search-input", "data", "equipment-mode", "onActiveMatch", "onOnClose"])
      ]),
      treeList: _withCtx(() => [
        (_ctx.adminMode && _ctx.isAdminLogin)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_checkbox, {
                id: "chkFilterEnabled",
                modelValue: _ctx.state.filterEnabled,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.filterEnabled) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_k_label, { for: "chkFilterEnabled" }, {
                    default: _withCtx(() => [
                      _createElementVNode("b", null, _toDisplayString(_ctx.localize('Filter')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _createVNode(_component_tree_list, {
            "expand-field": _ctx.state.expandField,
            "sub-items-field": _ctx.state.subItemsField,
            "data-items": _ctx.processedData,
            columns: _ctx.columnDef,
            filter: _ctx.state.filter,
            filterable: _ctx.state.filterEnabled,
            sort: _ctx.state.sort,
            sortable: true,
            onDatastatechange: _ctx.handleDataStateChange,
            onExpandchange: _ctx.onExpandChange
          }, {
            renderMaterialNo: _withCtx(({props}) => [
              _createElementVNode("td", {
                class: _normalizeClass(props.class)
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.hoverOnDetailsLink()),
                  onClick: ($event: any) => (_ctx.redirectToMaterialView(props.dataItem))
                }, [
                  (props.dataItem.materialNo)
                    ? (_openBlock(), _createBlock(_component_search_match_viewer, {
                        key: 0,
                        node: props.dataItem,
                        text: props.dataItem.materialNo.toString(),
                        "expected-match-type": "materialNo",
                        "active-search-match": _ctx.activeSearchResult
                      }, null, 8, ["node", "text", "active-search-match"]))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_4)
              ], 2)
            ]),
            renderPurchaseButton: _withCtx(({props}) => [
              _createElementVNode("td", null, [
                (props.dataItem.materialNo)
                  ? (_openBlock(), _createBlock(_component_purchase_button, {
                      key: 0,
                      "material-number": props.dataItem.materialNo
                    }, null, 8, ["material-number"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            renderDescription: _withCtx(({props}) => [
              _createElementVNode("td", {
                id: `Node${props.dataItem.id}`,
                class: _normalizeClass(props.class),
                colspan: props.colSpan,
                "aria-colindex": props['aria-colindex'],
                "aria-expanded": props['aria-expanded'],
                "aria-selected": props['aria-selected'],
                role: props.role,
                "data-grid-col-index": props['data-grid-col-index'],
                style: {"padding":"2px"}
              }, [
                _createElementVNode("table", _hoisted_6, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", {
                      class: _normalizeClass(_ctx.pointerClass(props.dataItem)),
                      onClick: ($event: any) => (_ctx.onExpandChange({ dataItem: props.dataItem, value: props['aria-expanded']}))
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.level.slice(1), (iteration, index) => {
                          return (_openBlock(), _createBlock(_component_my_icon, {
                            icon: "none",
                            key: index
                          }))
                        }), 128)),
                        _createElementVNode("span", {
                          class: _normalizeClass(_ctx.getExpansionIconClasses(props.dataItem, props['aria-expanded'])),
                          "data-prevent-selection": true
                        }, null, 2)
                      ])
                    ], 10, _hoisted_7),
                    _createElementVNode("td", {
                      class: _normalizeClass(["cell-description", _ctx.pointerClass(props.dataItem)]),
                      onClick: ($event: any) => (_ctx.onExpandChange({ dataItem: props.dataItem, value: props['aria-expanded']}))
                    }, [
                      (props.dataItem.expandIconClass != '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createVNode(_component_indicator, {
                              text: props.dataItem.description,
                              rounded: "medium",
                              class: _normalizeClass(_ctx.getClassesForSpecialNode(props.dataItem.nodeType)),
                              clickable: true
                            }, null, 8, ["text", "class"])
                          ]))
                        : (props.dataItem.materialNo)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass(["node-material-text", props.dataItem.hiddenSparePart ? 'hidden-material' : ''])
                            }, [
                              _createElementVNode("div", {
                                style: {"display":"flex","flex-direction":"row","align-items":"center","gap":"5px"},
                                class: _normalizeClass(_ctx.hoverOnDetailsLink())
                              }, [
                                _createVNode(_component_search_match_viewer, {
                                  node: props.dataItem,
                                  text: props.dataItem.description,
                                  "expected-match-type": "description",
                                  "active-search-match": _ctx.activeSearchResult
                                }, null, 8, ["node", "text", "active-search-match"])
                              ], 2),
                              (props.dataItem.salesText)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _createVNode(_component_search_match_viewer, {
                                      node: props.dataItem,
                                      text: props.dataItem.salesText,
                                      "expected-match-type": "salesText",
                                      "active-search-match": _ctx.activeSearchResult
                                    }, null, 8, ["node", "text", "active-search-match"])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2))
                          : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(props.dataItem.description), 1))
                    ], 10, _hoisted_9),
                    (props.dataItem.isCategoryNode && _ctx.adminMode)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_13))
                      : (_ctx.adminMode)
                        ? (_openBlock(), _createElementBlock("td", {
                            key: 1,
                            class: _normalizeClass(props.dataItem.materialNo ? 'with-border' : '')
                          }, [
                            _createVNode(_component_material_explode_bar, {
                              item: props.dataItem,
                              onToggleChildNode: _ctx.toggleChildNode,
                              onShowDetails: _ctx.showDetails
                            }, null, 8, ["item", "onToggleChildNode", "onShowDetails"])
                          ], 2))
                        : _createCommentVNode("", true)
                  ])
                ])
              ], 10, _hoisted_5)
            ]),
            renderStatus: _withCtx(({props}) => [
              _createElementVNode("td", {
                class: _normalizeClass(props.className),
                style: {"overflow":"visible"}
              }, [
                _createVNode(_component_stock_indicator, {
                  "material-item": props.dataItem
                }, null, 8, ["material-item"])
              ], 2)
            ]),
            renderRightJustified: _withCtx(({props}) => [
              _createElementVNode("td", {
                class: _normalizeClass(props.className),
                style: {"text-align":"right"}
              }, _toDisplayString(props.dataItem[props.field]), 3)
            ]),
            renderPrice: _withCtx(({props}) => [
              _createElementVNode("td", {
                class: _normalizeClass(props.className),
                style: {"text-align":"right","white-space":"nowrap"}
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.materialPrice(props.dataItem)), 1)
              ], 2)
            ]),
            _: 1
          }, 8, ["expand-field", "sub-items-field", "data-items", "columns", "filter", "filterable", "sort", "onDatastatechange", "onExpandchange"])
        ], 512), [
          [_vShow, _ctx.hasLoaded]
        ])
      ]),
      _: 1
    }, 8, ["panes", "onChange"]),
    (_ctx.adminMode)
      ? (_openBlock(), _createBlock(_Transition, {
          key: 0,
          name: "slide"
        }, {
          default: _withCtx(() => [
            (_ctx.state.detailsItem != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_component_close_button_header, {
                    background: "",
                    onClose: _ctx.closeDetails
                  }, null, 8, ["onClose"]),
                  _createVNode(_component_material_details, {
                    "material-data": _ctx.state.detailsItem,
                    onNewMaterial: _ctx.onDetailsChanged
                  }, null, 8, ["material-data", "onNewMaterial"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}